<template>
  <v-hover>
    <v-expansion-panel
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 5 : 2}`"
      class="mb-3 parent-expansion withRemove"
      style="position: relative"
    >
      <div class="horiz-left-coloured-bg">
        <v-icon color="secondary" class="mt-0 ml-2 horiz-left-coloured-bg--icon"
          >trending_up</v-icon
        >
      </div>
      <v-expansion-panel-content class="rounded-3"      v-on:click="togglePanel()">
        <div slot="header">
          <h3
            class="
              text-truncate
              py-1
              ml-2
              pl-4
              horiz-left-coloured-bg--padding-header
            "
          >
            {{ metric.name }}
          </h3>
          <v-btn @click.stop="confirmDelete()" class="expansion-remove-btn" icon>
            <v-icon color="error">cancel</v-icon>
          </v-btn>
        </div>
        <!-- <v-layout class="horiz-left-coloured-bg--padding"> -->
          <metric-form :addMetricForm="isActive" :metric=metric></metric-form>
        <!-- </v-layout> -->
          <confirmation-dialog 
            title="Delete Metric"
            message="Are you sure you want to delete this metric and all the measurements that have been collected with it?"
            confirmButtonLabel="Yes, delete this metric"
            :showDialog="showDeleteDialog" 
            v-on:confirm="deleteMetric()" 
            v-on:cancel="cancelDelete()"></confirmation-dialog>

      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-hover>
</template>

<script>
import MetricForm from "./MetricForm.vue";
import ConfirmationDialog from "@/components/shared/ConfirmationDialog.vue";

export default {
  name: "Metric",
  components: {MetricForm, ConfirmationDialog},
  props: {
    metric: {
      type: Object,
      required: true
    }
  },
  methods: {
    confirmDelete() {
      this.showDeleteDialog = true
    },
    cancelDelete() {
      this.showDeleteDialog = false
    },
    deleteMetric() {
      this.$store.dispatch("deleteMetric", this.metric)
    },
    togglePanel() {
      this.isActive = !this.isActive
    }
  },
  data: () => {
    return {
      isActive: true,
      addMetricButton: true,
      addMetricForm: false,
      showDeleteDialog: false
    };
  },   
};
</script>